import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

import { ref, computed } from 'vue';
import { useMutation } from '@vue/apollo-composable';

import { DataObjectRenameDocument, DataObjectType } from '@/gql/graphql';

import {
  BAlert,
  BButton,
  BFormGroup,
  BFormInput,
  BModal,
  BSpinner,
} from 'bootstrap-vue-next';
import { formatFileName } from '@/utils/file-utils';

// --- Component properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'DataObjectRename',
  props: {
    show: { type: Boolean },
    dataObject: {},
    bucketId: {}
  },
  emits: ['close', 'closeAndRefresh'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// --- Component emits ---
const emits = __emit;

// --- Component state ---
const dataObjectNameUpdate = ref<string>(formatFileName(props.dataObject.name));

const show = computed<boolean>(() => {
  return props.show;
});

// --- Mutation: Rename Data Object ---
const mutationInProgress = ref<boolean>(false);
const mutationError = ref<string | null>(null);
const mutationShowSuccess = ref<boolean>(false);

const {
  mutate: executeMutation,
  onDone: onMutationDone,
  onError: onMutationError,
} = useMutation(DataObjectRenameDocument);

onMutationDone((res) => {
  mutationInProgress.value = false;
  if (res.data && res.data.dataObjectRename) {
    console.debug('Data object renamed:', res.data.dataObjectRename);
    mutationShowSuccess.value = true;
    setTimeout(() => {
      mutationShowSuccess.value = false;
      emits('closeAndRefresh');
    }, 1000);
  } else {
    mutationError.value = 'Renaming failed: ' + res.data;
    console.error('Data object renaming failed:', res.data);
  }
});

onMutationError((err) => {
  console.error('Error renaming data object:', err);
  mutationInProgress.value = false;
  mutationError.value = err.message;
});

// --- Handle component actions ---
function onRenameConfirmed() {
  if (!props.dataObject) {
    mutationError.value = 'Data object not provided for deletion';
    console.error('Data object not provided for deletion');
    return;
  }
  if (typeof props.dataObject.name !== 'string') {
    mutationError.value = 'Data object name is not a string';
    console.error('Data object name is not a string:', props.dataObject.name);
    return;
  }
  if (typeof props.dataObject.isFolder !== 'boolean') {
    mutationError.value = 'Data object `isFolder` field type is not a boolean';
    console.error(
      'Data object `isFolder` field type is not a boolean:',
      props.dataObject.isFolder
    );
    return;
  }
  if (!dataObjectNameUpdate.value) {
    mutationError.value = 'New name is empty';
    console.error('New name is empty');
    return;
  }

  mutationInProgress.value = true;
  mutationError.value = null;
  executeMutation({
    bucketId: props.bucketId,
    oldObjectName: props.dataObject.name,
    newObjectName: dataObjectNameUpdate.value,
    isFolder: props.dataObject.isFolder,
  });
}

function handleCloseModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BModal), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((show).value = $event)),
      onHide: handleCloseModal
    }, {
      title: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "pencil",
          class: "me-2"
        }),
        _cache[4] || (_cache[4] = _createTextVNode(" Rename ", -1)),
        _createElementVNode("strong", null, _toDisplayString(_unref(formatFileName)(__props.dataObject?.name)), 1),
        (__props.dataObject)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (__props.dataObject.isFolder)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, " folder "))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, " file "))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(BButton), {
          variant: "secondary",
          onClick: handleCloseModal
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode(" Cancel ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(BButton), {
          variant: "primary",
          onClick: onRenameConfirmed
        }, {
          default: _withCtx(() => [
            (mutationInProgress.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _cache[6] || (_cache[6] = _createTextVNode(" Saving Changes ", -1)),
                  _createVNode(_unref(BSpinner), {
                    small: "",
                    label: ""
                  })
                ]))
              : (mutationShowSuccess.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _cache[7] || (_cache[7] = _createTextVNode(" Changes Saved ", -1)),
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fa', 'check-double'],
                      class: "me-2"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, " Save Changes "))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (__props.dataObject)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(BFormGroup), {
                label: "New name",
                "label-for": "storage-object-name-update",
                class: "mt-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BFormInput), {
                    modelValue: dataObjectNameUpdate.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dataObjectNameUpdate).value = $event)),
                    id: "storage-object-name-update",
                    name: "storage-object-name-update",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BAlert), {
                modelValue: mutationError.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((mutationError).value = $event)),
                variant: "danger",
                dismissible: "",
                class: "mt-3",
                onDismissed: _cache[2] || (_cache[2] = ($event: any) => (mutationError.value = null))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(mutationError.value), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})